module.exports = __webpack_public_path__ + "img/menu1.07e77b33.png";